import React, { useState } from "react";

const SongCommentInput = ({ onSubmit, loading }) => {
  const [text, setText] = useState("");

  const handleSubmit = () => {
    const trimmed = text.trim();
    if (!trimmed || loading) return;

    onSubmit(trimmed);
    setText("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <div
      style={{
        display: "flex",
        gap: "10px",
        marginBottom: "15px",
      }}
    >
      <input
        type="text"
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Write a comment..."
        disabled={loading}
        style={{
          flex: 1,
          padding: "10px",
          borderRadius: "6px",
          border: "1px solid #ddd",
        }}
      />

      <button
        onClick={handleSubmit}
        disabled={loading || !text.trim()}
        style={{
          padding: "10px 16px",
          borderRadius: "6px",
          border: "none",
          cursor: loading ? "not-allowed" : "pointer",
          background: "#111",
          color: "#fff",
          opacity: loading ? 0.6 : 1,
        }}
      >
        {loading ? "Posting..." : "Post"}
      </button>
    </div>
  );
};

export default SongCommentInput;